import React from 'react'

const TabButtonSection = ({ activeTab, handleTabClick }) => {
    return (
        <>
            <div className='hidden lg:flex mb-5'>
                <button className={`flex items-center bg-charcoal font-TTHakgyoansimYeohaengR w-[99%] h-[50px] font-medium text-lg xl:text-[26px] cursor-pointer mx-[0.5%] pl-[30px] pr-5 rounded-[10px] border border-slate hover:bg-blue-glow hover:border-[#0306d4] hover:text-[#ffcc00] ${activeTab === 1 ? 'bg-blue-glow border-[#0306d4] text-[#ffcc00]' : 'text-white'} `}
                    onClick={() => handleTabClick(1)}>
                    카지노
                    <span className='text-[60%] ml-[5px]'>CASINO</span>&nbsp;
                    <i className='fi fi-rr-dice-alt text-lg xl:text-xl ms-auto flex '></i>
                </button>
                <button className={`flex items-center bg-charcoal font-TTHakgyoansimYeohaengR w-[99%] h-[50px] font-medium text-lg xl:text-[26px] cursor-pointer mx-[0.5%] pl-[30px] pr-5 rounded-[10px] border border-slate hover:bg-blue-glow hover:border-[#0306d4] hover:text-[#ffcc00] ${activeTab === 2 ? 'bg-blue-glow border-[#0306d4] text-[#ffcc00]' : 'text-white'} `}
                    onClick={() => handleTabClick(2)}>
                    슬롯게임
                    <span className='text-[60%] ml-[5px]'>SLOT</span>&nbsp;
                    <i className='fi fi-rr-slot-machine text-lg xl:text-xl ms-auto flex '></i>
                </button>
                <button className={`flex items-center bg-charcoal font-TTHakgyoansimYeohaengR w-[99%] h-[50px] font-medium text-lg xl:text-[26px] cursor-pointer mx-[0.5%] pl-[30px] pr-5 rounded-[10px] border border-slate hover:bg-blue-glow hover:border-[#0306d4] hover:text-[#ffcc00] ${activeTab === 3 ? 'bg-blue-glow border-[#0306d4] text-[#ffcc00]' : 'text-white'} `}
                    onClick={() => handleTabClick(3)}>
                    미니게임
                    <span className='text-[60%] ml-[5px]'>MINI</span>&nbsp;
                    <i className='fi fi-rr-gamepad text-lg xl:text-xl ms-auto flex '></i>
                </button>
            </div>
            <div className='flex lg:hidden m-[5px] h-[45px]'>
                <button className={`flex flex-1 items-center justify-center gap-1 bg-graphite font-NotoSansKR font-bold  text-[15px]  text-[#ccc]  cursor-pointer mx-[3px] rounded-[10px]  hover:bg-blue-glow hover:text-[#fff] ${activeTab === 1 ? 'bg-blue-glow  text-[#fff]' : ''}`}
                    onClick={() => handleTabClick(1)}>
                    <i className='fi fi-rr-poker-chip text-lg flex'></i>
                    <span>카지노</span>
                </button>
                <button className={`flex flex-1 items-center justify-center gap-1 bg-graphite font-NotoSansKR font-bold  text-[15px]  text-[#ccc]  cursor-pointer mx-[3px] rounded-[10px]  hover:bg-blue-glow hover:text-[#fff] ${activeTab === 2 ? 'bg-blue-glow  text-[#fff]' : ''}`}
                    onClick={() => handleTabClick(2)}>
                    <i className='fi fi-rr-dice-d10 text-lg flex'></i>
                    <span>슬롯</span>
                </button>
                <button className={`flex flex-1 items-center justify-center gap-1 bg-graphite font-NotoSansKR font-bold  text-[15px]  text-[#ccc]  cursor-pointer mx-[3px] rounded-[10px]  hover:bg-blue-glow hover:text-[#fff] ${activeTab === 3 ? 'bg-blue-glow  text-[#fff]' : ''}`}
                    onClick={() => handleTabClick(3)}>
                    <i className='fi fi-rr-joystick text-lg flex'></i>
                    <span>미니게임</span>
                </button>
            </div>
        </>
    )
}

export default TabButtonSection